var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("body"),_vm._v(" "),_c('div',{staticClass:"approvals"},[_c('ul',{staticClass:"col-md-12"},_vm._l((_vm.approvalUsersData),function(user){return _c('li',{key:user.id},[_vm._v("\n        "+_vm._s(user.FirstName)+" "+_vm._s(user.LastName)+"\n      ")])}),0),_vm._v(" "),_c('br',{staticStyle:{"clear":"both"}})])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ced1b82","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/Programs/Card-cards/attachments-details.vue
// module id = Cshb
// module chunks = 12